import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import './news.scss';

// Components
// ---------------------
import { Tabs } from '../../components/tabs/tabs';

export const News = ({ ...props }) => {
  const [tabs] = useState([
    {
      label: 'Market Alerts',
      path: 'market-alerts',
    },
    {
      label: 'Securities Updates',
      path: 'securities-updates',
    },
    {
      label: 'Securities Suspensions',
      path: 'securities-suspensions',
    },
    {
      label: 'News & Updates',
      path: 'news-and-updates',
    },
  ]);

  const currentPath = useLocation().pathname.split('/').at(-1);
  tabs.forEach((t) => {
    t.active = t.path === currentPath;
  });

  return (
    <div className={`news-page`}>
      <Tabs data={tabs} aria={`Goldman Sachs News Categories`} />
      <Outlet />
    </div>
  );
};
